import axios from "axios";

const SERVICES_URL = process.env.SERVICES_URL;
const API_URL = `${SERVICES_URL}/api/v1/user`;

export const getCommenters = (): Promise<string[]> =>
  axios.get(`${API_URL}/commenters`).then(response => response.data);

export const getLoggedInUser = (): Promise<any> => axios.get(`${API_URL}`).then(response => response.data);
